import { Types } from "@grandvisionhq/graphql";
const mapNonPrescriptionBundleLineItem = ({
  sku,
  quantity,
  bundleLineItems
}) => {
  const mainBundleLineItem = {
    sku,
    quantity: 1,
    // The quantity of the entire bundle is indicated on the root level of the bundle.
    isMainBundleLineItem: true
  };
  return {
    sku,
    quantity: quantity ?? 1,
    lineItemType: Types.LineItemType.BUNDLE,
    bundleLineItemsType: Types.BundleLineItemType.NON_PRESCRIPTION_BUNDLE,
    bundleLineItems: [
      mainBundleLineItem,
      ...bundleLineItems.map((item) => ({
        ...item,
        quantity: item.quantity ?? 1,
        isMainBundleLineItem: false
      }))
    ]
  };
};
export {
  mapNonPrescriptionBundleLineItem
};
//# sourceMappingURL=non-prescription-bundle.js.map
